/* La fattura nata dall'incasso di un avviso, da passare su Fatture Smart.
 *
 * Adattatore sottile come `FatturaAcconto`: carica il testo (modificabile,
 * con "l'ultima volta") e il totale atteso, e li passa alla pagina a passi.
 * Il testo ritoccato si salva quando si copia; il numero e' l'unica fonte di
 * numerazione, perche' due numeratori che contano ciascuno per conto suo
 * divergono alla prima fattura fatta a mano.
 */

import { documenti } from "../api";
import { useCarica } from "../carica";
import {
  dataCompleta,
  giorniDa,
  scadenzaFattura,
  type Documento,
  type TestoFatturaSmart,
} from "../dominio";
import { PassiFattura, type DatiPassi } from "./PassiFattura";

function datiDi(d: Documento, t: TestoFatturaSmart): DatiPassi {
  // La fattura prende la data dell'incasso: da li' contano i 12 giorni.
  const scad = scadenzaFattura(giorniDa(d.data), d.data);
  return {
    chi: d.intestatario,
    cosa: "Fattura",
    contesto: `Incassata il ${dataCompleta(d.data)}${d.descrizione ? `, ${d.descrizione}` : ""}.`,
    scadenza: scad,
    testo: t.testo,
    modificabile: t.modificabile,
    importoRiga: t.importo,
    totaleAtteso: t.totale_atteso,
    controllo: t.controllo.map((c) => ({ etichetta: c.etichetta, valore: c.valore })),
    iva: t.iva,
    avvertenze: t.da_guardare,
    ultimaVolta: t.ultima_volta,
  };
}

export function FatturaNormale({
  d,
  posizione,
  numeriUsati,
  chiudi,
  registrato,
}: {
  d: Documento;
  posizione: { i: number; n: number } | null;
  numeriUsati: string[];
  chiudi: () => void;
  /** Dopo aver registrato il numero: ricarica le code e porta alla fattura successiva. */
  registrato: () => Promise<void>;
}) {
  const caricato = useCarica<TestoFatturaSmart>(() => documenti.testo(d.identificativo), [d.identificativo]);
  const t = caricato.dati;

  if (caricato.errore) {
    return (
      <article className="documento passi-fattura">
        <button type="button" className="tasto tasto-nudo torna" onClick={chiudi}>
          ‹ Torna all'elenco
        </button>
        <p className="errore" role="alert">
          {caricato.errore}
        </p>
      </article>
    );
  }
  if (t === undefined) {
    return (
      <article className="documento passi-fattura">
        <p className="attesa">Un momento.</p>
      </article>
    );
  }
  return (
    <PassiFattura
      dati={datiDi(d, t)}
      posizione={posizione}
      numeriUsati={numeriUsati}
      chiudi={chiudi}
      salvaTesto={async (testo) => {
        await documenti.salvaTesto(d.identificativo, testo);
        await caricato.ricarica();
      }}
      registra={async (numero) => {
        await documenti.numera(d.identificativo, numero);
        await registrato();
      }}
    />
  );
}
